import { useMutation } from "@apollo/client/react";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import { SEND_INVOICE_TO_VALIDATION } from "../../mutations/invoices/sendInvoiceToValidation";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useSendInvoiceToValidation = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [sendInvoiceToValidation, { data, loading, error }] = useMutation(
    SEND_INVOICE_TO_VALIDATION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [
            GET_CLIENT_INVOICES,
            GET_CLIENTS_WITH_INVOICES,
            GET_INVOICE_LATEST_VALIDATION_RESULT,
            GET_CLIENT_ASSESSMENT_INVOICES,
            GET_INVOICE_ASSESSMENT_DETAILS,
          ],
      awaitRefetchQueries: true,
    },
  );

  return { sendInvoiceToValidation, data, loading, error };
};
